import { render } from "./UpdatePasswordDialog.vue?vue&type=template&id=13c29ebd"
import script from "./UpdatePasswordDialog.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__